import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingItemWrapper: {
    ...theme.mixins.appClickableContainer,
    ...theme.mixins.appContainersSpacing,
  },

  trainingItemHeader: {
    display: 'flex',
    gap: 1,
    minWidth: 0,
    width: '100%',
  },
  trainingContentColumn: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  trainingTitleRow: {
    display: 'flex',
    gap: theme.spacing(1),
    width: '100%',
    alignItems: 'flex-start',
    minWidth: 0,
  },
  trainingTitleColumn: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  icon: {
    color: theme.palette.success.main,
  },

  buttonsWrapper: {
    display: 'flex',
    gap: theme.spacing(0.5),
    alignItems: 'flex-start',
    flexShrink: 0,

    button: {
      display: 'flex',
      gap: theme.spacing(0.5),
    },
  },
  trainingItemContent: {
    // padding: 16,
  },

  menuItem: {
    '& .icon': {
      marginRight: 8,
    },
    '&:hover': {
      '& svg': {
        color: theme.palette.grey[600],
      },
    },
  },
}));
